import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {}

export const useAuditHistoryStore = storeWrapper('useAuditHistoryStore', (set) => ({
  ...initialState,
  fetchExpenseClaimAuditHistoryByExpenseClaimId: async ({ expenseClaimId: expenseClaimId }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: `fetchExpenseClaimAuditHistory-${expenseClaimId}`,
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              method: 'GET',
              service: 'accounts',
              endpoint: `/ExpenseClaimAuditItem/GetAllByExpenseClaimId`,
              data: { expenseClaimId: expenseClaimId }
            })

            resolve(response)
          } catch (error) {
            console.error('Error fetching expense claim audit history:', error)
            reject(error)
            return
          }
        }
      })
    })
  },
  fetchOvertimeClaimAuditHistoryByOvertimeClaimId: async ({ overtimeClaimId }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: `fetchOvertimeClaimAuditHistory-${overtimeClaimId}`,
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              method: 'GET',
              service: 'accounts',
              endpoint: `/OvertimeClaimAuditItem/GetAllByOvertimeClaimId`,
              data: { overtimeClaimId: overtimeClaimId }
            })
            resolve(response)
          } catch (error) {
            console.error('Error fetching overtime claim audit history:', error)
            reject(error)
            return
          }
        }
      })
    })
  },
  reset: () => set(initialState)
}))
